import ce, { useState as oe, useEffect as We } from "react";
function gr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var ie = { exports: {} }, M = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var re, Me;
function Be() {
  if (Me)
    return re;
  Me = 1;
  var t = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, f = 0; f < 10; f++)
        l["_" + String.fromCharCode(f)] = f;
      var d = Object.getOwnPropertyNames(l).map(function(h) {
        return l[h];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var y = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        y[h] = h;
      }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return re = a() ? Object.assign : function(i, l) {
    for (var f, d = o(i), y, h = 1; h < arguments.length; h++) {
      f = Object(arguments[h]);
      for (var j in f)
        u.call(f, j) && (d[j] = f[j]);
      if (t) {
        y = t(f);
        for (var R = 0; R < y.length; R++)
          c.call(f, y[R]) && (d[y[R]] = f[y[R]]);
      }
    }
    return d;
  }, re;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ze;
function mr() {
  if (ze)
    return M;
  ze = 1, Be();
  var t = ce, u = 60103;
  if (M.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var c = Symbol.for;
    u = c("react.element"), M.Fragment = c("react.fragment");
  }
  var o = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, d, y) {
    var h, j = {}, R = null, b = null;
    y !== void 0 && (R = "" + y), d.key !== void 0 && (R = "" + d.key), d.ref !== void 0 && (b = d.ref);
    for (h in d)
      a.call(d, h) && !i.hasOwnProperty(h) && (j[h] = d[h]);
    if (f && f.defaultProps)
      for (h in d = f.defaultProps, d)
        j[h] === void 0 && (j[h] = d[h]);
    return { $$typeof: u, type: f, key: R, ref: b, props: j, _owner: o.current };
  }
  return M.jsx = l, M.jsxs = l, M;
}
var te = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Le;
function yr() {
  return Le || (Le = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var u = ce, c = Be(), o = 60103, a = 60106;
      t.Fragment = 60107;
      var i = 60108, l = 60114, f = 60109, d = 60110, y = 60112, h = 60113, j = 60120, R = 60115, b = 60116, I = 60121, W = 60122, fe = 60117, de = 60129, pe = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var E = Symbol.for;
        o = E("react.element"), a = E("react.portal"), t.Fragment = E("react.fragment"), i = E("react.strict_mode"), l = E("react.profiler"), f = E("react.provider"), d = E("react.context"), y = E("react.forward_ref"), h = E("react.suspense"), j = E("react.suspense_list"), R = E("react.memo"), b = E("react.lazy"), I = E("react.block"), W = E("react.server.block"), fe = E("react.fundamental"), E("react.scope"), E("react.opaque.id"), de = E("react.debug_trace_mode"), E("react.offscreen"), pe = E("react.legacy_hidden");
      }
      var ve = typeof Symbol == "function" && Symbol.iterator, Fe = "@@iterator";
      function $e(e) {
        if (e === null || typeof e != "object")
          return null;
        var r = ve && e[ve] || e[Fe];
        return typeof r == "function" ? r : null;
      }
      var N = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function T(e) {
        {
          for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
            n[s - 1] = arguments[s];
          Ve("error", e, n);
        }
      }
      function Ve(e, r, n) {
        {
          var s = N.ReactDebugCurrentFrame, g = s.getStackAddendum();
          g !== "" && (r += "%s", n = n.concat([g]));
          var m = n.map(function(v) {
            return "" + v;
          });
          m.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, m);
        }
      }
      var Ge = !1;
      function qe(e) {
        return !!(typeof e == "string" || typeof e == "function" || e === t.Fragment || e === l || e === de || e === i || e === h || e === j || e === pe || Ge || typeof e == "object" && e !== null && (e.$$typeof === b || e.$$typeof === R || e.$$typeof === f || e.$$typeof === d || e.$$typeof === y || e.$$typeof === fe || e.$$typeof === I || e[0] === W));
      }
      function He(e, r, n) {
        var s = r.displayName || r.name || "";
        return e.displayName || (s !== "" ? n + "(" + s + ")" : n);
      }
      function he(e) {
        return e.displayName || "Context";
      }
      function k(e) {
        if (e == null)
          return null;
        if (typeof e.tag == "number" && T("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
          return e.displayName || e.name || null;
        if (typeof e == "string")
          return e;
        switch (e) {
          case t.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case l:
            return "Profiler";
          case i:
            return "StrictMode";
          case h:
            return "Suspense";
          case j:
            return "SuspenseList";
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case d:
              var r = e;
              return he(r) + ".Consumer";
            case f:
              var n = e;
              return he(n._context) + ".Provider";
            case y:
              return He(e, e.render, "ForwardRef");
            case R:
              return k(e.type);
            case I:
              return k(e._render);
            case b: {
              var s = e, g = s._payload, m = s._init;
              try {
                return k(m(g));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var z = 0, ge, me, ye, _e, be, we, Ee;
      function xe() {
      }
      xe.__reactDisabledLog = !0;
      function Ze() {
        {
          if (z === 0) {
            ge = console.log, me = console.info, ye = console.warn, _e = console.error, be = console.group, we = console.groupCollapsed, Ee = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: xe,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          z++;
        }
      }
      function Ke() {
        {
          if (z--, z === 0) {
            var e = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: c({}, e, {
                value: ge
              }),
              info: c({}, e, {
                value: me
              }),
              warn: c({}, e, {
                value: ye
              }),
              error: c({}, e, {
                value: _e
              }),
              group: c({}, e, {
                value: be
              }),
              groupCollapsed: c({}, e, {
                value: we
              }),
              groupEnd: c({}, e, {
                value: Ee
              })
            });
          }
          z < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var q = N.ReactCurrentDispatcher, H;
      function B(e, r, n) {
        {
          if (H === void 0)
            try {
              throw Error();
            } catch (g) {
              var s = g.stack.trim().match(/\n( *(at )?)/);
              H = s && s[1] || "";
            }
          return `
` + H + e;
        }
      }
      var Z = !1, U;
      {
        var Je = typeof WeakMap == "function" ? WeakMap : Map;
        U = new Je();
      }
      function je(e, r) {
        if (!e || Z)
          return "";
        {
          var n = U.get(e);
          if (n !== void 0)
            return n;
        }
        var s;
        Z = !0;
        var g = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var m;
        m = q.current, q.current = null, Ze();
        try {
          if (r) {
            var v = function() {
              throw Error();
            };
            if (Object.defineProperty(v.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(v, []);
              } catch (S) {
                s = S;
              }
              Reflect.construct(e, [], v);
            } else {
              try {
                v.call();
              } catch (S) {
                s = S;
              }
              e.call(v.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (S) {
              s = S;
            }
            e();
          }
        } catch (S) {
          if (S && s && typeof S.stack == "string") {
            for (var p = S.stack.split(`
`), O = s.stack.split(`
`), w = p.length - 1, x = O.length - 1; w >= 1 && x >= 0 && p[w] !== O[x]; )
              x--;
            for (; w >= 1 && x >= 0; w--, x--)
              if (p[w] !== O[x]) {
                if (w !== 1 || x !== 1)
                  do
                    if (w--, x--, x < 0 || p[w] !== O[x]) {
                      var P = `
` + p[w].replace(" at new ", " at ");
                      return typeof e == "function" && U.set(e, P), P;
                    }
                  while (w >= 1 && x >= 0);
                break;
              }
          }
        } finally {
          Z = !1, q.current = m, Ke(), Error.prepareStackTrace = g;
        }
        var Y = e ? e.displayName || e.name : "", Ye = Y ? B(Y) : "";
        return typeof e == "function" && U.set(e, Ye), Ye;
      }
      function Re(e, r, n) {
        return je(e, !1);
      }
      function Qe(e) {
        var r = e.prototype;
        return !!(r && r.isReactComponent);
      }
      function F(e, r, n) {
        if (e == null)
          return "";
        if (typeof e == "function")
          return je(e, Qe(e));
        if (typeof e == "string")
          return B(e);
        switch (e) {
          case h:
            return B("Suspense");
          case j:
            return B("SuspenseList");
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case y:
              return Re(e.render);
            case R:
              return F(e.type, r, n);
            case I:
              return Re(e._render);
            case b: {
              var s = e, g = s._payload, m = s._init;
              try {
                return F(m(g), r, n);
              } catch {
              }
            }
          }
        return "";
      }
      var Ce = {}, Oe = N.ReactDebugCurrentFrame;
      function $(e) {
        if (e) {
          var r = e._owner, n = F(e.type, e._source, r ? r.type : null);
          Oe.setExtraStackFrame(n);
        } else
          Oe.setExtraStackFrame(null);
      }
      function Xe(e, r, n, s, g) {
        {
          var m = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var v in e)
            if (m(e, v)) {
              var p = void 0;
              try {
                if (typeof e[v] != "function") {
                  var O = Error((s || "React class") + ": " + n + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw O.name = "Invariant Violation", O;
                }
                p = e[v](r, v, s, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (w) {
                p = w;
              }
              p && !(p instanceof Error) && ($(g), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", n, v, typeof p), $(null)), p instanceof Error && !(p.message in Ce) && (Ce[p.message] = !0, $(g), T("Failed %s type: %s", n, p.message), $(null));
            }
        }
      }
      var L = N.ReactCurrentOwner, K = Object.prototype.hasOwnProperty, er = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Te, ke, J;
      J = {};
      function rr(e) {
        if (K.call(e, "ref")) {
          var r = Object.getOwnPropertyDescriptor(e, "ref").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.ref !== void 0;
      }
      function tr(e) {
        if (K.call(e, "key")) {
          var r = Object.getOwnPropertyDescriptor(e, "key").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.key !== void 0;
      }
      function nr(e, r) {
        if (typeof e.ref == "string" && L.current && r && L.current.stateNode !== r) {
          var n = k(L.current.type);
          J[n] || (T('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', k(L.current.type), e.ref), J[n] = !0);
        }
      }
      function ar(e, r) {
        {
          var n = function() {
            Te || (Te = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          n.isReactWarning = !0, Object.defineProperty(e, "key", {
            get: n,
            configurable: !0
          });
        }
      }
      function or(e, r) {
        {
          var n = function() {
            ke || (ke = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          n.isReactWarning = !0, Object.defineProperty(e, "ref", {
            get: n,
            configurable: !0
          });
        }
      }
      var ir = function(e, r, n, s, g, m, v) {
        var p = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: o,
          // Built-in properties that belong on the element
          type: e,
          key: r,
          ref: n,
          props: v,
          // Record the component responsible for creating this element.
          _owner: m
        };
        return p._store = {}, Object.defineProperty(p._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(p, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: s
        }), Object.defineProperty(p, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: g
        }), Object.freeze && (Object.freeze(p.props), Object.freeze(p)), p;
      };
      function sr(e, r, n, s, g) {
        {
          var m, v = {}, p = null, O = null;
          n !== void 0 && (p = "" + n), tr(r) && (p = "" + r.key), rr(r) && (O = r.ref, nr(r, g));
          for (m in r)
            K.call(r, m) && !er.hasOwnProperty(m) && (v[m] = r[m]);
          if (e && e.defaultProps) {
            var w = e.defaultProps;
            for (m in w)
              v[m] === void 0 && (v[m] = w[m]);
          }
          if (p || O) {
            var x = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
            p && ar(v, x), O && or(v, x);
          }
          return ir(e, p, O, g, s, L.current, v);
        }
      }
      var Q = N.ReactCurrentOwner, Pe = N.ReactDebugCurrentFrame;
      function D(e) {
        if (e) {
          var r = e._owner, n = F(e.type, e._source, r ? r.type : null);
          Pe.setExtraStackFrame(n);
        } else
          Pe.setExtraStackFrame(null);
      }
      var X;
      X = !1;
      function ee(e) {
        return typeof e == "object" && e !== null && e.$$typeof === o;
      }
      function Se() {
        {
          if (Q.current) {
            var e = k(Q.current.type);
            if (e)
              return `

Check the render method of \`` + e + "`.";
          }
          return "";
        }
      }
      function cr(e) {
        {
          if (e !== void 0) {
            var r = e.fileName.replace(/^.*[\\\/]/, ""), n = e.lineNumber;
            return `

Check your code at ` + r + ":" + n + ".";
          }
          return "";
        }
      }
      var Ie = {};
      function ur(e) {
        {
          var r = Se();
          if (!r) {
            var n = typeof e == "string" ? e : e.displayName || e.name;
            n && (r = `

Check the top-level render call using <` + n + ">.");
          }
          return r;
        }
      }
      function Ae(e, r) {
        {
          if (!e._store || e._store.validated || e.key != null)
            return;
          e._store.validated = !0;
          var n = ur(r);
          if (Ie[n])
            return;
          Ie[n] = !0;
          var s = "";
          e && e._owner && e._owner !== Q.current && (s = " It was passed a child from " + k(e._owner.type) + "."), D(e), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, s), D(null);
        }
      }
      function Ne(e, r) {
        {
          if (typeof e != "object")
            return;
          if (Array.isArray(e))
            for (var n = 0; n < e.length; n++) {
              var s = e[n];
              ee(s) && Ae(s, r);
            }
          else if (ee(e))
            e._store && (e._store.validated = !0);
          else if (e) {
            var g = $e(e);
            if (typeof g == "function" && g !== e.entries)
              for (var m = g.call(e), v; !(v = m.next()).done; )
                ee(v.value) && Ae(v.value, r);
          }
        }
      }
      function lr(e) {
        {
          var r = e.type;
          if (r == null || typeof r == "string")
            return;
          var n;
          if (typeof r == "function")
            n = r.propTypes;
          else if (typeof r == "object" && (r.$$typeof === y || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          r.$$typeof === R))
            n = r.propTypes;
          else
            return;
          if (n) {
            var s = k(r);
            Xe(n, e.props, "prop", s, e);
          } else if (r.PropTypes !== void 0 && !X) {
            X = !0;
            var g = k(r);
            T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", g || "Unknown");
          }
          typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fr(e) {
        {
          for (var r = Object.keys(e.props), n = 0; n < r.length; n++) {
            var s = r[n];
            if (s !== "children" && s !== "key") {
              D(e), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", s), D(null);
              break;
            }
          }
          e.ref !== null && (D(e), T("Invalid attribute `ref` supplied to `React.Fragment`."), D(null));
        }
      }
      function De(e, r, n, s, g, m) {
        {
          var v = qe(e);
          if (!v) {
            var p = "";
            (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (p += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var O = cr(g);
            O ? p += O : p += Se();
            var w;
            e === null ? w = "null" : Array.isArray(e) ? w = "array" : e !== void 0 && e.$$typeof === o ? (w = "<" + (k(e.type) || "Unknown") + " />", p = " Did you accidentally export a JSX literal instead of a component?") : w = typeof e, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w, p);
          }
          var x = sr(e, r, n, g, m);
          if (x == null)
            return x;
          if (v) {
            var P = r.children;
            if (P !== void 0)
              if (s)
                if (Array.isArray(P)) {
                  for (var Y = 0; Y < P.length; Y++)
                    Ne(P[Y], e);
                  Object.freeze && Object.freeze(P);
                } else
                  T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ne(P, e);
          }
          return e === t.Fragment ? fr(x) : lr(x), x;
        }
      }
      function dr(e, r, n) {
        return De(e, r, n, !0);
      }
      function pr(e, r, n) {
        return De(e, r, n, !1);
      }
      var vr = pr, hr = dr;
      t.jsx = vr, t.jsxs = hr;
    }();
  }(te)), te;
}
process.env.NODE_ENV === "production" ? ie.exports = mr() : ie.exports = yr();
var _ = ie.exports;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var G = function() {
  return G = Object.assign || function(u) {
    for (var c, o = 1, a = arguments.length; o < a; o++) {
      c = arguments[o];
      for (var i in c)
        Object.prototype.hasOwnProperty.call(c, i) && (u[i] = c[i]);
    }
    return u;
  }, G.apply(this, arguments);
};
function _r(t, u) {
  var c = {};
  for (var o in t)
    Object.prototype.hasOwnProperty.call(t, o) && u.indexOf(o) < 0 && (c[o] = t[o]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, o = Object.getOwnPropertySymbols(t); a < o.length; a++)
      u.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[a]) && (c[o[a]] = t[o[a]]);
  return c;
}
function br(t, u) {
  u === void 0 && (u = {});
  var c = u.insertAt;
  if (!(!t || typeof document > "u")) {
    var o = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
    a.type = "text/css", c === "top" && o.firstChild ? o.insertBefore(a, o.firstChild) : o.appendChild(a), a.styleSheet ? a.styleSheet.cssText = t : a.appendChild(document.createTextNode(t));
  }
}
var wr = `.styles-module_content-container__4wuQ0 {
  display: flex;
  justify-content: center;
  align-items: center;
}`, Er = { "content-container": "styles-module_content-container__4wuQ0" };
br(wr);
var xr = {
  primary: "p-btn--primary",
  secondary: "p-btn--secondary",
  secondaryGrey: "p-btn--secondary-grey",
  outline: "p-btn--outline",
  outlineGrey: "p-btn--outline-grey"
}, jr = ce.forwardRef(function(t, u) {
  var c = t.className, o = t.loading, a = o === void 0 ? !1 : o, i = t.buttonTitle, l = t.buttonType, f = l === void 0 ? "primary" : l, d = t.leftIcon;
  t.type;
  var y = _r(t, ["className", "loading", "buttonTitle", "buttonType", "leftIcon", "type"]), h = xr[f], j = a ? "p-btn--loading" : "";
  return _.jsx("button", G({ ref: u, className: h + " " + j + " " + (c ?? "") }, y, { children: d ? _.jsxs("div", G({ className: Er["content-container"] }, { children: [
    _.jsx("img", { width: "20px", height: "20px", className: "mr8", src: d.src, alt: d.alt }, void 0),
    _.jsx("div", { children: i }, void 0)
  ] }), void 0) : _.jsx(_.Fragment, { children: i }, void 0) }), void 0);
});
const ne = jr;
var Ue = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var u = {}.hasOwnProperty;
    function c() {
      for (var o = [], a = 0; a < arguments.length; a++) {
        var i = arguments[a];
        if (i) {
          var l = typeof i;
          if (l === "string" || l === "number")
            o.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var f = c.apply(null, i);
              f && o.push(f);
            }
          } else if (l === "object") {
            if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
              o.push(i.toString());
              continue;
            }
            for (var d in i)
              u.call(i, d) && i[d] && o.push(d);
          }
        }
      }
      return o.join(" ");
    }
    t.exports ? (c.default = c, t.exports = c) : window.classNames = c;
  })();
})(Ue);
var Rr = Ue.exports;
const ae = /* @__PURE__ */ gr(Rr), C = {
  functionality_storage: "functionality_storage",
  ad_storage: "ad_storage",
  analytics_storage: "analytics_storage",
  ad_user_data: "ad_user_data",
  ad_personalization: "ad_personalization"
};
/*! js-cookie v3.0.5 | MIT */
function V(t) {
  for (var u = 1; u < arguments.length; u++) {
    var c = arguments[u];
    for (var o in c)
      t[o] = c[o];
  }
  return t;
}
var Cr = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function se(t, u) {
  function c(a, i, l) {
    if (!(typeof document > "u")) {
      l = V({}, u, l), typeof l.expires == "number" && (l.expires = new Date(Date.now() + l.expires * 864e5)), l.expires && (l.expires = l.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var f = "";
      for (var d in l)
        l[d] && (f += "; " + d, l[d] !== !0 && (f += "=" + l[d].split(";")[0]));
      return document.cookie = a + "=" + t.write(i, a) + f;
    }
  }
  function o(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], l = {}, f = 0; f < i.length; f++) {
        var d = i[f].split("="), y = d.slice(1).join("=");
        try {
          var h = decodeURIComponent(d[0]);
          if (l[h] = t.read(y, h), a === h)
            break;
        } catch {
        }
      }
      return a ? l[a] : l;
    }
  }
  return Object.create(
    {
      set: c,
      get: o,
      remove: function(a, i) {
        c(
          a,
          "",
          V({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return se(this.converter, V({}, this.attributes, a));
      },
      withConverter: function(a) {
        return se(V({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(u) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var ue = se(Cr, { path: "/" });
const le = "_fccs", Or = Object.freeze({
  [C.functionality_storage]: "granted",
  [C.ad_storage]: "denied",
  [C.analytics_storage]: "denied",
  [C.ad_user_data]: "denied",
  [C.ad_personalization]: "denied"
}), Tr = (t) => {
  if (t === C.functionality_storage)
    return "granted";
  const u = ue.get(le);
  return (typeof u == "string" ? u.split("|") : []).includes(t) ? "granted" : "denied";
}, kr = () => {
  const t = { ...Or };
  return Object.keys(t).forEach((u) => {
    t[u] = Tr(u);
  }), t;
}, Pr = () => !!ue.get(le), Sr = (t) => typeof window > "u" || !t || !t.length ? !1 : t.includes(window.location.pathname), Vr = (t) => {
  if (typeof window > "u")
    return;
  window.dataLayer = window.dataLayer || [];
  function u() {
    window.dataLayer.push(arguments);
  }
  u("consent", "update", t), u("event", "consent_updated");
}, Ir = {
  expires: 365,
  sameSite: "lax",
  domain: process.env.NODE_ENV === "development" ? void 0 : "feather-insurance.com"
}, Ar = (t) => {
  ue.set(le, t.join("|"), Ir);
}, Nr = () => {
  const [t, u] = oe(!0), c = Pr();
  return We(() => {
    c || u(!1);
  }, [c]), { hiddenBanner: t, setCookie: (a) => {
    Ar(a), u(!0);
  } };
}, Dr = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik00LjY2NjUgMTEuMzMyN0wxMS4zMzMyIDQuNjY2MDIiIHN0cm9rZT0iIzhFOENFRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik00LjY2NjUgNC42NjYwMkgxMS4zMzMyVjExLjMzMjciIHN0cm9rZT0iIzhFOENFRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Yr = "_wrapper_xvbir_1", Mr = "_overlay_xvbir_15", zr = "_container_xvbir_21", Lr = "_overflow_xvbir_27", Wr = "_label_xvbir_38", Br = "_footer_xvbir_43", Ur = "_disabled_xvbir_66", A = {
  wrapper: Yr,
  overlay: Mr,
  container: zr,
  overflow: Lr,
  label: Wr,
  footer: Br,
  disabled: Ur
}, Fr = [
  {
    id: C.functionality_storage,
    title: "Essential cookies",
    required: !0,
    description: "These cookies are necessary to provide a functional website to you. They enable features such as allowing you to log in to view your purchased policies, or to be able to pick up where you left off while signing up for insurance. As these cookies are essential to use our website, they cannot be rejected. You can however block or delete them through your browser settings. Be aware that this will impact the functionality of our site."
  },
  {
    id: C.ad_storage,
    title: "Marketing cookies",
    description: "We use these cookies and pixels to improve our marketing efforts. They allow us to determine, which of our ads work best (through conversion tracking) and which ones we should stop running. Disabling these cookies does not affect your use of our site."
  },
  {
    id: C.analytics_storage,
    title: "Performance cookies",
    description: "These cookies help us make our website better. They store information about how you use our website, such as the links you click on. All of this data is anonymised and can not be used to identify you. Although important to us, these cookies are non-essential to the use of the site."
  },
  {
    id: C.ad_personalization,
    title: "Personalization cookies",
    description: "These cookies allow us to use your anonymized data to personalize advertising so we don’t show you irrelevant ads."
  },
  {
    id: C.ad_user_data,
    title: "User data cookies",
    description: /* @__PURE__ */ _.jsxs("p", { children: [
      "These cookies allow us to share data related to advertising with Google, in order to help us maintain the quality of our advertising. More information about how Google uses this data can be found",
      " ",
      /* @__PURE__ */ _.jsx("a", { href: "https://business.safety.google/privacy", className: "p-a", children: "here" }),
      "."
    ] })
  }
], Gr = (t) => {
  const { onSave: u, allowScrollOnPaths: c } = t, [o, a] = oe(!1), [i, l] = oe([
    C.functionality_storage,
    C.ad_storage,
    C.analytics_storage,
    C.ad_user_data,
    C.ad_personalization
  ]), { hiddenBanner: f, setCookie: d } = Nr(), y = Sr(c);
  We(() => {
    if (!(f || y))
      return document.body.style.overflow = "hidden", () => {
        document.body.style.overflow = "auto";
      };
  }, [f, y]);
  const h = (b) => {
    const I = b.target.id;
    if (i.indexOf(I) === -1) {
      l([...i, I]);
      return;
    }
    l(i.filter((W) => W !== I));
  }, j = () => {
    l([C.functionality_storage]), a(!0);
  }, R = (b) => {
    b.preventDefault(), d(i), u(kr());
  };
  return f ? null : /* @__PURE__ */ _.jsx(
    "div",
    {
      className: ae("d-flex", A.wrapper, {
        [A.overlay]: !y
      }),
      children: /* @__PURE__ */ _.jsxs(
        "div",
        {
          className: ae("wmx6 w100 ml-auto ta-left", A.container, {
            "bs-sm": y
          }),
          children: [
            /* @__PURE__ */ _.jsx("h4", { className: "p-h4 mb16", children: "Cookies 🍪" }),
            /* @__PURE__ */ _.jsxs("div", { className: A.overflow, children: [
              /* @__PURE__ */ _.jsx("p", { className: "p-p p-p--small", children: "We use 1st and 3rd party cookies and pixels to continuously improve our website and your browsing experience. These cookies also allow us to use your anonymized data to personalize advertising so we don’t show you irrelevant ads. You can choose which cookies you would like to accept. Your experience does not change depending on this choice, but by allowing us to use cookies you directly help us identify issues with our site and improve the service we can offer." }),
              /* @__PURE__ */ _.jsxs(
                "a",
                {
                  href: "https://feather-insurance.com/privacy-policy",
                  className: "p-a p-p--small d-flex mt8",
                  children: [
                    "Learn more",
                    /* @__PURE__ */ _.jsx(
                      "img",
                      {
                        alt: "Open in new window",
                        src: Dr,
                        width: 16,
                        height: 18
                      }
                    )
                  ]
                }
              ),
              o && /* @__PURE__ */ _.jsx("form", { children: Fr.map((b) => /* @__PURE__ */ _.jsxs("div", { className: "p-label-container", children: [
                /* @__PURE__ */ _.jsx(
                  "input",
                  {
                    id: b.id,
                    className: "p-checkbox",
                    type: "checkbox",
                    disabled: b.required,
                    checked: b.required ? !0 : i.includes(b.id),
                    onChange: h
                  }
                ),
                /* @__PURE__ */ _.jsx(
                  "label",
                  {
                    htmlFor: b.id,
                    className: ae(
                      "p-label p-h4 mt24 mb8",
                      A.label,
                      {
                        [A.disabled]: b.required
                      }
                    ),
                    children: b.title
                  }
                ),
                /* @__PURE__ */ _.jsx("p", { className: "p-p p-p--small ml32", children: b.description })
              ] }, b.id)) })
            ] }),
            /* @__PURE__ */ _.jsx("div", { className: `mt16 ${A.footer}`, children: o ? /* @__PURE__ */ _.jsx(
              ne,
              {
                buttonTitle: "Save",
                onClick: R,
                className: "w100"
              }
            ) : /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
              /* @__PURE__ */ _.jsx(
                ne,
                {
                  buttonTitle: "Edit",
                  buttonType: "secondary",
                  onClick: j,
                  className: "w100"
                }
              ),
              /* @__PURE__ */ _.jsx(
                ne,
                {
                  buttonTitle: "Accept all",
                  onClick: R,
                  className: "w100"
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
};
export {
  le as COOKIE_KEY,
  Gr as CookieBanner,
  Pr as consentCookieExists,
  C as cookieType,
  Sr as getAllowPageScroll,
  kr as getCurrentConsent,
  Vr as updateConsentInTagManager
};
//# sourceMappingURL=cookie-consent.js.map
